import request from "@/utils/http";
import { apiUrl } from "./config.js";

export function login(data) {
    return request({
        url: apiUrl.baseUrl + "/login",
        method: "post",
        data: data,
    });
}
export function checkToken(data) {
    return request({
        url: apiUrl.baseUrl + "/checkToken",
        method: "get",
        params: data,
    });
}

export function linuxdoLogin(data) {
    return request({
        url: apiUrl.baseUrl + "/linuxdo/login",
        method: "get",
        params: data,
    });
}




export function getWhois(data) {
    return request({
        url: apiUrl.baseUrl + "/whois",
        method: "get",
        params: data,
    });
}

export function getCrt(data) {
    return request({
        url: apiUrl.baseUrl + "/crt",
        method: "get",
        params: data,
    });
}

export function getWxBlock(data) {
    return request({
        url: apiUrl.baseUrl + "/wxblock",
        method: "get",
        params: data,
    });
}

